import axios, {AxiosResponse} from 'axios';
import { Login } from '../Components/UserLogin/Login';
import {  ApprovalVM, FeedBackVM } from '../Models/ViewModels';
const api_url = process.env.REACT_APP_STEM_API_BASE_URL+'/api';

const headers = { 
    'Accept': 'application/json',
    'Content-Type': 'application/json'
}

export const GetApprovalDetails=(loginId:any)=>{
    return axios.get(api_url+'/KRAApproval/KraApprovalDetails?managerid='+loginId);
}

export const ApproveData=(id:any,loginId:any)=>{
    var ids = id.toString();
    const payload = {
        "ids":ids,
        "loginId": loginId,
        "action": "Approve"
    }
    console.log(payload)
    return axios.post(api_url+'/KRAApproval/ApproveKRA', payload, {headers});
}

export const RejectData=(id:any,loginId:any)=>{
    const ids = id.toString();
    const payload = {
        "ids":ids,
        "loginId": loginId,
        "action": "Reject"
    }
    return axios.post(api_url+'/KRAApproval/ApproveKRA', payload, {headers});
}

export const EditKra=(editkra:ApprovalVM,loginid:any,checkDesig:any)=>{
    const Submitteddate=editkra.SubmittedOn.split('/').reverse().join('/')
    const payload = { "ID":editkra.ID,"AccountName":editkra.AccountName,
    "ProcessName":editkra.ProcessName,"SubStateName":editkra.SubStateName,"ProductionCount":editkra.ProductionCount,
    "Remarks":editkra.Remarks,"SubmittedOn":Submitteddate,"checkDesig":checkDesig,"loginid":loginid};
    console.log(payload)
    return axios.post(api_url+'/KRAApproval/ApprovalEdit/',payload,{headers});
}

export const GetAccountDropDown=(loginid:any)=>{
    return axios.get(api_url+'/Account/GetAccountDropdown?loginid='+loginid);
}

export const GetProductivityReport=(loginid:any,type:any)=>{
    return axios.get(api_url+'/KRAApproval/TeamProductivityReport?loginid='+loginid+'&type='+type);
}
export const GetPKTReport=(managerid:any)=>{
    return axios.get(api_url+'/KRAApproval/GetPKTDetails?ManagerId='+managerid);
}
export const GetQualityReport=(managerid:any)=>{
    return axios.get(api_url+'/KRAApproval/GetQualityModule?ManagerId='+managerid);
}
export const GetAttendanceReport=(loginid:any)=>{
    return axios.get(api_url+'/KRAApproval/GetAttendanceDetails?empId='+loginid);
}
export const GetProductionTargetValue=(EmployeeID:any,AccountName:any,SubStateName:any,ProcessName:any)=>{
    return axios.get(api_url+'/KRAApproval/GetProductionTargetScreen?EmployeeID='+EmployeeID+'&AccountName='+AccountName+'&SubStateName='+
    SubStateName+'&ProcessName='+ProcessName);
}
export const SetRole=(loginId:any,Role:any)=>{
    console.log(api_url+'/KRAApproval/ChangeRole?loginid='+loginId+'&Role='+Role)
    return axios.get(api_url+'/KRAApproval/ChangeRole?loginid='+loginId+'&Role='+Role);
}
export const GetFeedBackScreen=(year:any,managerid:any)=>{
    return axios.get(api_url+'/KRAApproval/GetFeedBackScreen?FeedBackYear='+year+'-01&ManagerId='+managerid);
}

export const GetOverallKRAReport=(year:any,managerid:any)=>{
    return axios.get(api_url+'/KRAApproval/GetOverallKRAReport?InputYear='+year+'&loginid='+managerid);
}

export const ManagerFeedBack=(feedBack:FeedBackVM,loginId:any)=>{
    const payload= {"EmployeeOfficeBadgeId":feedBack.EmployeeOfficeBadgeId,"FeedBack":feedBack.FeedBack,
    "FeedbackYear":feedBack.FeedBackYear,"UpdatedBy":loginId,"Comments":feedBack.Comments }
    return axios.post(api_url+'/KRAApproval/Feedback',payload,{headers})
}

export const GetTotalProcessBuffer=(loginId:any)=>{
    return axios.get(api_url+'/Teams/GetProcessBuffer?empId='+loginId);
}

export const FeedBackEdit=(feedBack:FeedBackVM,loginId:any)=>{  
    const payload= {"ID":feedBack.ID,"FeedBack":feedBack.FeedBack,
    "FeedbackYear":feedBack.FeedBackYear,"UpdatedBy":loginId,"Comments":feedBack.Comments }    
    return axios.post(api_url+'/KRAApproval/EditFeedback',payload,{headers})
}

export const GetProcessSubstareDropDown=(accountName:string,processName:string)=>{
    return axios.get(api_url+'/KRAApproval/GetProcessSubstareDropDown?accountName='+accountName+'&processName='+processName)
}

export const DownloadExcelForOverallKRA=(inputYear:any,loginId:any)=>{
    return axios.post(api_url+'/KRAApproval/DownloadExcel?inputYear='+inputYear+'&loginid='+loginId,{},{responseType:'blob'});
}
